import Vue from 'vue';
import LoginDialog from "./index.vue";

const insertBody = (elx, parent) => {
    let bodyx = parent ? parent : document.body
    bodyx.insertBefore(elx, bodyx.firstChild)
}


const dialogConstructor = Vue.extend(LoginDialog);

let instance;

export default { name:'loginDialog', function(props) {
        instance = new dialogConstructor();

        instance.$props.text = props.text
        instance.$props.title = props.title || 'Dialog'
        instance.$props.color = props.color
        instance.$props.type = props.type || 'alert'
        instance.$props.buttonAccept = props.buttonAccept || 'filled'
        instance.$props.buttonCancel = props.buttonCancel || 'flat'
        instance.$props.acceptText = props.acceptText || 'Accept'
        instance.$props.cancelText = props.cancelText || 'Cancel'
        instance.$props.closeIcon = props.closeIcon || 'close'
        instance.$props.iconPack = props.iconPack || 'material-icons'
        instance.$props.isValid = props.isValid || 'none'

        instance.$data.isPrompt = false

        instance.vm = instance.$mount();

        props.accept?instance.vm.$on('accept', props.accept):null
        props.cancel?instance.vm.$on('cancel', props.cancel):null
        insertBody(instance.vm.$el, props.parent);

        Vue.nextTick(() => {
            instance.$data.fActive = true
            instance.$data.parameters = props.parameters
        });
    }
}
